/**
 * Toggle Phoenix enrollment/redeem (registerRetailUser + redeemPromotionCode).
 * When false, forms use the legacy Falcon redeemPromotion flow.
 */
export default function isPhoenixEnrollmentEnabled(): boolean {
  return process.env.NEXT_PUBLIC_USE_PHOENIX_ENROLLMENT === 'true';
}

/**
 * Uber-only toggle for initiatePartnerDriverEnrollment vs loginPartnerDriver,
 * and Phoenix redeem on the Uber portal.
 */
export function isPhoenixUberEnrollmentEnabled(): boolean {
  return process.env.NEXT_PUBLIC_USE_PHOENIX_UBER_ENROLLMENT === 'true';
}
